import React, { useCallback } from "react";
import { AppointmentSartoria, AppointmentSartoriaOther, AppointmentTypes, ItemAppointment } from "../../../Models/Types.ts";

interface ModalAppointmentMergeProps {
    handleClosingAppointmentMerge: () => void,
    appointmentToMerge: Array<AppointmentSartoria>,
    onMergeAppointment: (arriveIndex: number) => void,
    ownerIndex : number
}

const ModalAppointmentMerge = (props: ModalAppointmentMergeProps) => {
    const { handleClosingAppointmentMerge, appointmentToMerge, onMergeAppointment, ownerIndex } = props;

    const stateContainer = useCallback((item: ItemAppointment) => {
        console.log(item)
        let stateReturn = <></>
        if (item.stato.toLowerCase() === "Prendere le misure".toLowerCase()) {
            stateReturn = <div className="container-state-appointment-icon"> Per <div className="state-appointment"> <i className="fa-solid fa-ruler"></i> {item.stato} </div></div>
        } else if ( item.stato.toLowerCase() === "Prova".toLowerCase()) {
            stateReturn = <div className="container-state-appointment-icon">Per la <div className="state-appointment"> <i className="fa-solid fa-box-heart"></i>  {item.stato} </div></div>
        } else if (item.stato.toLowerCase() === "Prova con consegna".toLowerCase()) {
            if (AppointmentTypes.toString(item.tipo) === "Uomo" || AppointmentTypes.toString(item.tipo) === "Sposo") {
                stateReturn = <div className="container-state-appointment-icon">  Per la <div className="state-appointment"> <i className="fa-solid fa-person"></i> {item.stato} </div></div>
            } else {
                stateReturn = <div className="container-state-appointment-icon">Per la <div className="state-appointment"> <i className="fa-solid fa-person-dress"></i> {item.stato} </div></div>
            }
        }

        return stateReturn;

    }, [appointmentToMerge])
    
    return <>
        <div id="modal-container" className="modal-container">
            <div className="modal-appointment-date">
                <div className="modal-header">
                    <img onClick={handleClosingAppointmentMerge} id="back-to-form" className="icon" src="/calendario-appuntamenti/images/left-arrow.png" />
                </div>
                <div>
                    <div style={{ marginBottom: "30px" }}>Clicca un per unire ad un altro appuntamento</div>
                    {appointmentToMerge.map((aM, index) =>
                        <div onClick={() => { onMergeAppointment(index); handleClosingAppointmentMerge() }} style={{ marginBottom: "20px", cursor: "pointer", display : index === ownerIndex ? "none" : ""}} className="container-tile-appointment-retire">
                            {aM.items.map(item => <div className="tile-appointment-retire">
                                {stateContainer(item)}
                                <div className="appointment-name-container"><div /* className={"type-appointment-container " + ` type-${item.tipo}`} */>Abito da {AppointmentTypes.toString(item.tipo)}</div>di {item.appellativo}  {item.nome} </div>
                                <div>Contr. n. {item.nr_contratto} </div>
                            </div>)}
                        </div>)}
                </div>
            </div>
        </div>
    </>
}

export default ModalAppointmentMerge;